import UserRole, {Permission} from '../constants/userRoles'
import {UserModel} from '../models/UserModel'

export function isApplicant(roles: Array<string> = []) {
  return roles.includes(UserRole.APPLICANT)
}
export function isEmployee(roles: Array<string> = []) {
  return roles.includes(UserRole.EMPLOYEE)
}
export function isMentor(roles: Array<string> = []) {
  return roles.includes(UserRole.MENTOR)
}
export function isTeamLeader(roles: Array<string> = []) {
  return roles.includes(UserRole.TEAM_LEADER)
}
export function isHrManager(roles: Array<string> = []) {
  return roles.includes(UserRole.HR_ADMIN) || roles.includes(UserRole.HR_MANAGER)
}
export function isHiringManager(roles: Array<string> = []) {
  return roles.includes(UserRole.HR_MANAGER)
}
export function isCertifiedPointLeaderUser(roles: Array<string> = []) {
  return roles.includes(UserRole.CERTIFIED_POINTLEADER_USER)
}
export function isGlobalHrAdmin(roles: Array<string> = []) {
  return roles.includes(UserRole.GLOBAL_HR_ADMIN)
}
export function isManager(roles: Array<string> = []) {
  return roles.includes(UserRole.MANAGER)
}
export function isSuperAdmin(roles: Array<string> = []) {
  return roles.includes(UserRole.SUPER_ADMIN)
}

export function hasManagerRole(roles: Array<string> = []) {
  return (
    roles.includes(UserRole.MANAGER) ||
    roles.includes(UserRole.GLOBAL_HR_ADMIN) ||
    roles.includes(UserRole.SUPER_ADMIN)
  )
}

export function hasHrManagerRole(roles: Array<string> = []) {
  return (
    roles.includes(UserRole.HR_ADMIN) ||
    roles.includes(UserRole.HR_MANAGER) ||
    roles.includes(UserRole.GLOBAL_HR_ADMIN) ||
    roles.includes(UserRole.MANAGER) ||
    roles.includes(UserRole.SUPER_ADMIN)
  )
}

export function hasTeamLeaderRole(roles: Array<string> = []) {
  return (
    roles.includes(UserRole.TEAM_LEADER) ||
    // roles.includes(UserRole.HR_ADMIN) ||
    // roles.includes(UserRole.MANAGER) ||
    roles.includes(UserRole.SUPER_ADMIN)
  )
}

export function hasEmployeeRole(roles: Array<string> = []) {
  return (
    roles.includes(UserRole.EMPLOYEE) ||
    roles.includes(UserRole.HR_ADMIN) ||
    roles.includes(UserRole.HR_MANAGER) ||
    roles.includes(UserRole.MANAGER) ||
    roles.includes(UserRole.SUPER_ADMIN)
  )
}

export function hasApplicantRole(roles: Array<string> = []) {
  return roles.includes(UserRole.APPLICANT) || roles.includes(UserRole.SUPER_ADMIN)
}

export const getUserPermission = (user?: UserModel) => {
  if (!user || !user.roles.length) return Permission.Public
  const roles = user.roles
  if (isSuperAdmin(roles)) return Permission.SuperAdmin
  else if (hasManagerRole(roles)) return Permission.Manager
  else if (hasHrManagerRole(roles)) return Permission.Manager
  else if (hasTeamLeaderRole(roles)) return Permission.Manager
  else if (hasEmployeeRole(roles)) return Permission.Manager
  else if (hasApplicantRole(roles)) return Permission.Manager
  return Permission.Authorized
}

export function generateRandomString(length = 32) {
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => dec.toString(16).padStart(2, '0')).join('');
}

export function generateState() {
  return generateRandomString(16);
}

export function generateNonce() {
  return generateRandomString(32);
}

const permissionHelper = {
  isApplicant,
  isEmployee,
  isMentor,
  isTeamLeader,
  isHrManager,
  isGlobalHrAdmin,
  isManager,
  isSuperAdmin,
  isHiringManager,
  isCertifiedPointLeaderUser,

  hasManagerRole,
  hasHrManagerRole,
  hasTeamLeaderRole,
  hasEmployeeRole,
  hasApplicantRole,
  getUserPermission,
}

export default permissionHelper
